import {
  HELP_HISTORY_MAX_MESSAGES,
  HELP_HISTORY_MESSAGE_MAX_LENGTH,
  type HelpConversationMessage,
  type HelpDiagnosticResult,
  type AskHelpResponse,
  type CreateHelpFeedbackRequest,
  type HelpSource,
} from '@tcvs/shared';

export interface HelpTranscriptEntry extends HelpConversationMessage {
  sources?: HelpSource[];
  diagnostic?: HelpDiagnosticResult;
  interactionId?: string;
  question?: string;
  currentRoute?: string;
  generatedBy?: AskHelpResponse['generatedBy'];
  contentVersion?: string;
  feedbackState?: 'submitting' | 'submitted' | 'error';
}

export function helpDiagnosticStatusLabel(status: HelpDiagnosticResult['status']): string {
  switch (status) {
    case 'OK':
      return 'Current';
    case 'ATTENTION':
      return 'Needs attention';
    case 'BLOCKED':
      return 'Blocked';
    case 'NOT_FOUND':
      return 'Not found';
    case 'AMBIGUOUS':
      return 'Ambiguous';
  }
}

export function helpHistory(entries: readonly HelpTranscriptEntry[]): HelpConversationMessage[] {
  return entries.slice(-HELP_HISTORY_MAX_MESSAGES).map(({ role, content }) => ({
    role,
    content: content.slice(0, HELP_HISTORY_MESSAGE_MAX_LENGTH).trimEnd(),
  }));
}

export function helpFeedbackRequest(
  entry: HelpTranscriptEntry,
): CreateHelpFeedbackRequest | undefined {
  if (
    entry.role !== 'assistant' ||
    entry.interactionId === undefined ||
    entry.question === undefined
  ) {
    return undefined;
  }
  return {
    interactionId: entry.interactionId,
    question: entry.question,
    answer: entry.content,
    currentRoute: entry.currentRoute,
    generatedBy: entry.generatedBy,
    contentVersion: entry.contentVersion,
    sources: entry.sources?.map(({ id, title }) => ({ id, title })),
  };
}

export function helpSourceHref(source: HelpSource, currentRoute: string): string {
  if (!source.route.includes('{')) return source.route;
  const prefix = source.route.slice(0, source.route.indexOf('{'));
  if (currentRoute.startsWith(prefix)) return currentRoute;
  if (source.route.startsWith('/batches/')) return '/batches';
  if (source.route.startsWith('/storage/batches/')) return '/storage?section=Batches';
  if (source.route.startsWith('/catalog/')) return '/storage?section=Cards';
  return '/dashboard';
}
